import { ActionIcon, Button, Modal } from "@mantine/core";
import { Trash } from "tabler-icons-react";

import {
  CROSSBAR_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS,
  CROSSBAR_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES,
} from "_roles";

import { AccessRights } from "common/admin/auth/AccessRights";
import { Crossbar } from "crossbar/types/crossbar.model";
import { useState } from "react";

export function CrossbarAdminRow({
  crossbar,
  onEdit,
  onDelete,
}: {
  crossbar: Crossbar;
  onEdit: () => void;
  onDelete: () => void;
}) {
  const [opened, setOpened] = useState(false);
  const handleCloseModal = (): void => {
    onDelete();
    setOpened(false);
  };
  return (
    <tr>
      <td
        onClick={onEdit}
        className="cursor-pointer text-[#0000EE] hover:underline"
      >
        {crossbar.name}
      </td>
      <AccessRights
        authorizedOrganizations={
          CROSSBAR_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS
        }
        authorizedRoles={CROSSBAR_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES}
      >
        <td className="max-w-2">{crossbar.access.organization}</td>
      </AccessRights>
      <td>
        {new Date(Date.parse(crossbar.creationTime)).toLocaleString(undefined, {
          dateStyle: "short",
          timeStyle: "short",
        })}
      </td>
      <td className="min-w-4">
        <div className="flex">
          <ActionIcon onClick={() => setOpened(true)}>
            <Trash color="red" size={20} />
          </ActionIcon>
        </div>
      </td>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        centered
        radius={0}
        overflow="inside"
        withCloseButton={false}
      >
        <p className=" text-xl ">
          Are you sure to delete this Crossbar Challenge?
        </p>
        <div className="flex gap-40 mt-6">
          <Button
            style={{ backgroundColor: "#e30613", color: "white" }}
            onClick={handleCloseModal}
            className="w-24"
          >
            Yes
          </Button>
          <Button
            style={{ color: "white" }}
            onClick={() => setOpened(false)}
            className="w-24 bg-button-admin"
          >
            No
          </Button>
        </div>
      </Modal>
    </tr>
  );
}
